import React, { useRef } from 'react';
import styles from './TableCell.module.sass';

const TableCell = ({
    children,
    primary, size, position, offsetLeft,
    ...props
}: Props & any) => {
    const ref = useRef<any>();

    return <div
        {...props}
        ref={ref}
        className={`
            ${styles['tablecell']}
            ${styles['tablecell__state--'+(primary?'primary':'secondary')]}
            ${styles['tablecell__size--'+(size??'medium')]}
            ${styles['tablecell__position--'+(position??'static')]}
            ${styles['tablecell__state--'+(primary ? 'primary' : 'static')]}
        `}
        style={{
            left: offsetLeft ?? 0
        }}
    >
        { children }
    </div>;
}

interface Props {
    children?: any
    primary?: boolean
    id?: any
    offsetLeft?: number
    size?: 'small' | 'medium' | 'large'
    position?: 'fixed' | 'static'
}

export default React.memo(TableCell);